// Path: src\Components\Rewards\Bundle.jsx
import React, { useCallback, useEffect, useRef, useState } from 'react';
import Avatar from "../../images/Avatar.png";
import BuyBoxBtn from "../CommonFields/BuyBoxBtn";
import Coin from '../../images/coin.png'
import { bundleList } from "../../api/coinStore.api";
import { url } from '../../config/url';
import ListLoader from '../Common/ListLoader';
import { t } from 'i18next';
const Bundle = ({ isReedemPopup, setIsReedemPopup, reedemItem, setReedemItem, isReward, setIsReward, setIsBundle }) => {
  const [productList, setProductList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordPerPage, setRecordPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (currentPage <= totalPages)
      loadMore()
  }, [currentPage])

  const loadMore = async () => {
 
    fetchBundles()
    
  }

  const observer = useRef();
  const lastPostElementRef = useCallback(
    async (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          setCurrentPage((prevPage) => prevPage + 1);
        }
      });

      if (node) observer.current.observe(node);
    },
    [loading]
  );

  const fetchBundles = async () => {
    setLoading(true)
    try {
      let data = {
        pagination: {
          pageNo: currentPage,
          recordPerPage: recordPerPage,
          sortBy: 'order',
          sortDirection: "desc"
        }
      }

      const res = await bundleList(data);
      setLoading(false)
      if (res?.success && res?.data) {
        let list = []
        if (res?.data && res?.data?.length > 0) {
          for (let i = 0; i < res?.data?.length; i++) {
            let obj = { ...res?.data?.[i] }
            obj.index = i + 1
            list.push(obj)
          }
        }

        if (currentPage == 1) {
          setProductList(list);
        }
        else {
          setProductList([...productList, ...list])
        }
        setTotalPages(res?.totalPages);
      }
      else {
        setProductList([]);
      }
    } catch (error) {
      setLoading(false)
    }
  };

  const verifyAccount = (reward) => {
    setIsReedemPopup(true);
    setIsReward(false);
    setIsBundle(true);
    setReedemItem(reward);
  }

  const isNoData = productList.length <= 0;
  // const isNoData = true;
  return (
    <div>
      <div
        className="avatar bundle-avatar flex-wrap"
        style={isNoData ? { height: "50vh" } : {}}
      >
        {
          isNoData ? !loading && (
            <div className='no-record-found-center' style={{ width: "100%", height: "50vh" }}>
              <span className="text-center">no data found</span>
            </div>
          ) : productList?.map((item, index) => {
            return (
              <div className={`avatar-box width `} key={index} ref={productList?.length === index + 1 ? lastPostElementRef : null}>
                <div className="inner">
                  <div className="half-circle"></div>
                  <div className="avatar-image">
                    <img className="avatar-img" src={url?.IMAGE_URL + item?.avatar?.img?.default} alt={item?.avatar?.name} />
                    <div className="d-flex bundle-text justify-content-center mt-1">
                      <span className="text-center mb-0 f-14 d-flex flex-column">
                        <span className='bunddle-currency-name-ellipsis'>
                          {item?.coins}
                          <span>
                            <img src={url?.IMAGE_URL + item?.virtualCurrency?.img?.default} className="icon-20 mt-0 me-2" alt={item?.virtualCurrency?.name} />
                          </span>
                        </span>
                        <span>+</span>
                        <span>
                          {item?.avatar?.name?.length > 10 ? (
                            <marquee>{item?.avatar?.name?.toLowerCase()}</marquee>
                          ) : (
                            item?.avatar?.name?.toLowerCase()
                          )}
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
                {!item?.isPurchase ?
                  <div className='buy-box ' onClick={() => verifyAccount(item)}>
                    <div className='buy-box-back-card'>
                      <span className='f-12'>{t("rewards-store.buy_for")}</span>
                      <span className='f-18 f-bold'>
                        <span className='text-capitalize'>
                          {item?.currency?.code === "INR" ?
                            item?.currency?.symbol
                            :
                            <img className='rewardstore-img-icon-size' src={url?.IMAGE_URL + item?.currency?.img?.default} alt={item?.name} />
                          }
                        </span>
                        {" " + item?.amount}
                      </span>
                    </div>
                  </div>
                  :
                  <div className='buy-box '>
                    <div className='buy-box-back-card'>
                      <span className='f-18 f-bold'>
                        {t("rewards-store.bought")}
                      </span>
                    </div>
                  </div>
                }
              </div>
            )
          })
        }

        {loading && <div className='w-100 d-flex justify-content-center'> <ListLoader /></div>}

      </div>
    </div>
  );
};

export default Bundle;
